export const getAuthApiRoute = (url) =>
  `https://auth-api.mnbx.ir/v1/auth/api/${url}`;

export const getCMSApiRoute = (url) =>
  `https://cms-api.mnbx.ir/v1/cms/api/${url}`;
export const getBillingApiRoute = (url) =>
  `https://billing-api.mnbx.ir/v1/billing/api/${url}`;

export const getCMSImageURL = (imageName) =>
  `https://fcdn.manabakh.ir/images/${imageName}`;

export const getArtistImageURL = (imageName) =>
  `https://fcdn.manabakh.ir/images/${imageName}`;

export const getAdvertisementApiRoute = (url) =>
  `https://advertisement-api.mnbx.ir/v1/advertisement/api/${url}`;
